<template>
  <div class="scroll-up-box" :style="{'height': height+'px'}">
    <div class="scroll-list" :style="animateUp && animateUpStyle">
      <slot :list="scrollList"></slot>
    </div>
  </div>
</template>


<script>
import utils from '@/libs/utils';

export default {
  props: {
    list: {
      type: Array,
      required: true
    },
    height: {
      type: Number,
      default: 24 
    },
    second: {
      type: Number,
      default: 3
    }
  },
  data(){
    return {
      timer: null,
      animateUp: false,
      scrollList: [],
    }
  },
  computed: {
    animateUpStyle(){
      return this.animateUp ?  {
        transition: 'all 0.5s ease-in-out',
        transform: `translateY(-${this.height}px)`
      } : undefined
    }
  },
  watch: {
    list: {
      handler(val){
        this.scrollList = utils.deepCopy(val)
        this.timer = setInterval(this.scrollAnimate, this.second*1000)
      },
      immediate: true,
      deep: true
    }
  },
  destroyed(){
    clearInterval(this.timer)
    this.timer = null
  },
  methods: {
    scrollAnimate(){
      this.animateUp = true
      setTimeout(()=>{
        this.scrollList.push(this.scrollList[0])
        this.scrollList.shift()
        this.animateUp = false
      }, 600)
    },
  }

}

</script>


<style lang="less" scoped>
.scroll-up-box {
  overflow: hidden;
}
</style>


// WEBPACK FOOTER //
// src/components/common/animation/scroll-up-animation.vue